import React, { Component } from "react"

/* REST API */
import { create } from '../../../api/Brand'

/* Sweet alert */
import Swal from "sweetalert2"

/* Helpers */
import { utils, withRouter } from '../../../helpers'

/* Page CreateBrand */
class CreateBrand extends Component {


    constructor() {
        super()

        this.state = {
            name: "",
            slug: "",
            connectionType: "category",
            image: null,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Brands */
    load = () => {
    }


    /* Upload Image */
    upload = event => {
        let file = event.target.files[0]

        if (file) {
            this.setState({ image: file })
        }
    }


    /* Create */
    create = () => {

        const { name, slug, connectionType, image } = this.state
        const { navigate } = this.props

        if (name === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите название', showConfirmButton: false, timer: 1500 })
            return
        }

        if (slug === "") {
            Swal.fire({ icon: 'error', title: 'Ошибка!', text: 'Введите Key (URL)', showConfirmButton: false, timer: 1500 })
            return
        }


        const data = new FormData()
        data.append('image', image)
        data.append('name', name)
        data.append('slug', slug)
        data.append('connectionType', connectionType)

        create(data).then(response => {
            if (response.status === 200) {

                Swal.fire({
                    icon: 'success',
                    title: 'Успешна добавлена',
                    showConfirmButton: false,
                    timer: 1500,
                    didClose: () => {
                        navigate('/brand')
                    }
                })

            }
            else {
                Swal.fire({
                    icon: 'error',
                    title: 'Что-то пошло не так! Попробуйте позднее',
                    showConfirmButton: false,
                    timer: 1500
                })
            }
        }).catch(() => {
            Swal.fire({
                icon: 'error',
                title: 'Что-то пошло не так! Попробуйте позднее',
                showConfirmButton: false,
                timer: 1500
            })
        })

    }


    /* Draw Top */
    _top = () => {

        return (
            <div className="content-top">

                <div className="content-name">
                    <img src="/pictures/brand.png" alt="Brand" />
                    <p>Добавить бренд</p>
                </div>

            </div>
        )
    }


    /* Set Name */
    setName = event => {
        this.setState({ name: event.target.value })
        const slug = utils.translit(event.target.value)
        this.setState({ slug })
    }

    setConnectionType = (type) => {

        const { connectionType } = this.state

        if (connectionType !== type) {
            this.setState({ connectionType: type })
        }

        return

    }

    render = () => {

        const { name, slug, connectionType } = this.state

        return (
            <div className="content">
                {this._top()}

                <div className="content-box">

                    <div className="content-form-box">

                        <div className="content-form-half">

                            <p>Название бренда</p>
                            <input type="text" value={name} onChange={event => this.setName(event)} placeholder="Введите название" />

                            <p>Key (URL)</p>
                            <input type="text" value={slug} onChange={event => this.setState({ slug: event.target.value })} placeholder="Введите Key" />

                            <p>Показать</p>
                            <div className="connection-types">
                                <div className={`type ${connectionType === 'category' ? "active" : ""}`} onClick={() => this.setConnectionType('category')}><p>Категории</p></div>
                                <div className={`type ${connectionType === 'product' ? "active" : ""}`} onClick={() => this.setConnectionType('product')}><p>Продукты</p></div>
                            </div>

                            <div className="content-space" />

                            {/* <p>Картинка</p>
                            <label className="content-input-file">
                                <input onChange={event => this.upload(event)} type="file" name="file" accept="image/png, image/jpeg" />
                                <span className="content-input-file-button">Выберите файл</span>
                                <span className="content-input-file-text">
                                    {(image && image.name !== null) ? image.name : "Максимум 10MB"}
                                </span>
                            </label> */}

                        </div>

                        <div className="content-form-half">
                        </div>

                    </div>

                    <div className="content-form-bottom">
                        <div onClick={() => this.create()} className="content-form-button">Добавить</div>
                    </div>

                </div>

            </div>
        )
    }

}

export default withRouter(CreateBrand)